// extracted by mini-css-extract-plugin
export default {"buttonToAnswerQuestion":"R3-z","disabled":"S3-z","seeAllAnswers":"T3-z"};